import { CSSProperties } from 'react';

const THUMBNAIL_BACKGROUND_COLOR = 'rgb(242, 242, 242)';

export const THUMBNAIL_ERROR_CONTAINER_SX = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  backgroundColor: THUMBNAIL_BACKGROUND_COLOR,
  cursor: 'pointer',
};

export const THUMBNAIL_CONTAINER_SX = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  backgroundColor: THUMBNAIL_BACKGROUND_COLOR,
  cursor: 'pointer',
  position: 'relative',
  overflow: 'hidden',
};

export const THUMBNAIL_LOADING_OVERLAY_SX = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  backgroundColor: THUMBNAIL_BACKGROUND_COLOR,
  zIndex: 1,
};

export function getThumbnailContentStyle(
  loading: boolean
): CSSProperties {
  return {
    maxWidth: '100%',
    maxHeight: '100%',
    opacity: loading ? 0 : 1,
    transition: 'opacity 0.3s',
  };
}

export function getThumbnailImageStyle(thumbnailSize: number): CSSProperties {
  return {
    width: '100%',
    height: '100%',
    maxWidth: `${thumbnailSize}px`,
    maxHeight: `${thumbnailSize}px`,
    objectFit: 'contain',
  };
}

export function getWordThumbnailContentSx(loading: boolean) {
  return {
    width: '100%',
    height: '100%',
    padding: '8px',
    opacity: loading ? 0 : 1,
    transition: 'opacity 0.3s',
    overflow: 'hidden',
    fontSize: '8px',
    lineHeight: '1.2',
    '& p': { margin: '2px 0', fontSize: '8px' },
    '& h1': {
      margin: '4px 0',
      fontSize: '10px',
      fontWeight: 'bold',
    },
    '& h2': { margin: '3px 0', fontSize: '9px', fontWeight: 'bold' },
    '& h3': { margin: '2px 0', fontSize: '8px', fontWeight: 'bold' },
    '& ul, & ol': { margin: '2px 0', paddingLeft: '12px' },
    '& li': { fontSize: '8px' },
    '& table': { fontSize: '7px', borderCollapse: 'collapse' },
    '& td, & th': { border: '1px solid #ddd', padding: '2px' },
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '30%',
      background:
        'linear-gradient(to bottom, transparent, rgb(242, 242, 242))',
      pointerEvents: 'none',
    },
  } as const;
}
